export default {
  SET_SYSTEM_COUNTRIES(state, systemCountriesList) {
    state.list = systemCountriesList;
  },
  SET_EDITABLE_COUNTRY(state, country) {
    state.editableCountry = country;
  },
};
